import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';
let siteKey = '';
if (window.location.hostname.match('app')) {
    siteKey = '6LfweHAqAAAAADPESYgvejwXplIURPCq9Y_nhvKQ';
}
else {
    siteKey = '6LctjnAqAAAAALHU154D_OKwfhzq_-DjfhhEfPJA';
}
Vue.use(VueReCaptcha, {
    siteKey,
    loaderOptions: {
        autoHideBadge: true,
    },
});
